<template>
	<div class="batch-body">
		<div class="item-box">
			<span>客户：</span>
			<el-select v-model="cusId" class="filter-input" size='small' multiple collapse-tags>
				<el-option v-for="item in cusList" :value="item.syscodeid" :key="item.syscodeid" :label="item.name"></el-option>
			</el-select>
		</div>
		<div class="item-box">
			<el-checkbox v-model="validChecked"/>
			<span>生效日期：</span>
			<el-date-picker
				v-model="validDate"
				size="mini"
				:unlink-panels='true'
				type="daterange"
				range-separator="至"
				start-placeholder="开始日期"
				end-placeholder="结束日期"
				format='yyyy-MM-dd'
				value-format='yyyy-MM-dd'>
			</el-date-picker>
		</div>
		<div class="item-box">
			<el-checkbox v-model="inValidChecked"/>
			<span>失效日期：</span>
			<el-date-picker
				v-model="inValidDate"
				size="mini"
				type="daterange"
				:unlink-panels='true'
				range-separator="至"
				start-placeholder="开始日期"
				end-placeholder="结束日期"
				format='yyyy-MM-dd'
				value-format='yyyy-MM-dd'>
			</el-date-picker>
		</div>
		<div class="item-box">
			<el-checkbox v-model="goodsChecked"/>
			<span>商品名称：</span>
			<el-select
				size="mini"
				filterable
				:filter-method='filterHander'
				clearable
				v-model="goodsValue"
				placeholder="请输入商品"
				@clear="goodsClear"
				@keyup.enter.native="enterEvent"
			>
				<el-option
					v-for="item in goodsList"
					:key="item.id"
					:label="item.name"
					:value="item.id">
				</el-option>
			</el-select>
		</div>
		<div class="button-group">
			<el-button type="primary" size="small" class="fx-big-btn" @click="deleteHandle">删除</el-button>
			<el-button type="primary" plain size="small" class="fx-big-btn" @click="cancelClick">取消</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'deleteModal',
	props: {
		deleteModal: Boolean,
		customerName: String
	},
	data () {
		return {
			validChecked: false,
			cusId: [],
			cusList: [],
			validDate: [],
			inValidChecked: false,
			inValidDate: [],
			goodsChecked: false,
			goodsValue: '',
			goodsList: [],
			tipsContent: '',
			validTips: '',
			inValidTips: '',
			goodsTips: ''
		}
	},
	created () {
		this.getCusList()
	},
	methods: {
		getCusList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/getCustomerInfo`
			}).then(res => {
				if (res.result) {
					this.cusList = res.data
				}
			})
		},
		cancelClick () {
			this.$emit('cancel', false)
		},
		filterHander (value) {
			if (!value) {
				return
			}
			let params = {
				name: value
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/goods/getProductInfoByName/`,
				data: params
			}).then(res => {
				if (res.result) {
					this.goodsList = res.data
				}
			})
		},
		goodsClear () {
			this.goodsValue = ''
			this.goodsList = []
		},
		deleteHandle () {
			let selectedGoods = ''
			if (!this.validChecked && !this.inValidChecked && !this.goodsChecked) {
				this.$message.warning('请勾选条件后再删除商品！')
				return
			}
			if ((this.validChecked && (this.validDate.length < 1 || this.validDate === null)) || (this.inValidChecked && (this.inValidDate.length < 1 || this.inValidDate === null)) || (this.goodsChecked && !this.goodsValue)) {
				this.$message.error('勾选项对应的内容不得为空!')
				return
			}
			if (this.goodsList && this.goodsList.length > 0) {
				selectedGoods = this.goodsList.filter(item => {
					return item.id === this.goodsValue
				})
			}
			if (this.cusId.length === 0) {
				this.$message.error('请选择客户！')
				return
			}
			this.tipsContent = `将删除${this.validChecked ? '生效日期' + this.validDate[0] + '—' + this.validDate[1] + '期间' : ''}${this.inValidChecked ? '，失效日期' + this.inValidDate[0] + '—' + this.inValidDate[1] + '期间' : ''}${this.goodsChecked ? '，商品名称为' + selectedGoods[0].name : ''}的客户价格，是否确定`
			this.$confirm(this.tipsContent, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.deleteEvent()
			}).catch(() => {})
		},
		getCusName () {
			let arr = []
			this.cusList.forEach(item => {
				if (this.cusId.indexOf(item.syscodeid) !== -1) {
					arr.push(item.name)
				}
			})
			return arr.join(',')
		},
		deleteEvent () {
			let params = {
				beginBeginDate: this.validChecked ? this.validDate[0] || '' : '',
				beginEndDate: this.validChecked ? this.validDate[1] || '' : '',
				endBeginDate: this.inValidChecked ? this.inValidDate[0] || '' : '',
				endEndDate: this.inValidChecked ? this.inValidDate[1] || '' : '',
				pId: this.goodsChecked ? this.goodsValue : '',
				syscodeids: this.cusId.join(',')
			}
			let selectedGoods = ''
			if (this.goodsList && this.goodsList.length > 0) {
				selectedGoods = this.goodsList.filter(item => {
					return item.id === this.goodsValue
				})
			}
			let text = `${this.validChecked ? '生效日期' + this.validDate[0] + '—' + this.validDate[1] + '期间' : ''}${this.inValidChecked ? '，失效日期' + this.inValidDate[0] + '—' + this.inValidDate[1] + '期间' : ''}${this.goodsChecked ? '，商品名称为' + selectedGoods[0].name : ''}的客户价格`
			let changeData = {
				pre: { muldel: {} },
				cur: { muldel: { text: text, customerName: this.getCusName() } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/goods/batchDelSpecialPrice`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$emit('cancel', false)
					this.$message.success('删除成功！')
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.batch-body{
		display: flex;
		width :460px;
		border-top: 1px solid #199ed847;
	flex-direction: column;
		.item-box {
			display flex;
			justify-content: flex-start;
			align-items: center;
			margin-top: 20px;
			span {
				line-height 0;
			}
		}
		.el-checkbox {
			margin-right: 12px;
		}
		.el-date-editor--daterange.el-input__inner, .el-select {
			width: 300px;
		}
		.button-group {
			padding: 30px 80px 10px;
			display: flex;
			justify-content: space-around;
		}
}

</style>
<style lang="stylus">
.batch-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
